import React from "react";
import { Link } from "react-router-dom";
import {
    Typography,
    Tabs,
    Spin,
    Row,
    Col,
    Form,
    Input,
    Switch,
    TimePicker,
    Icon,
    Button,
    Modal,
    Checkbox,
    Select,
    Pagination,
    Radio,
    Upload,
    Popconfirm,
    LocaleProvider,
} from "antd";
import { Queries } from "../../../../graphql";
import { withApollo } from "react-apollo";
import moment from "moment/min/moment-with-locales";
import Container from "../../../../components/user/Container";
import AddMeeting from "../../../../components/user/from/MeetingManagement/AddMeeting";
import { UrlMeeting } from "../../../../utils/auth";
//////////////////////addmodalINTERNAL_SERVER_ERROR
import axios from "axios";
import ModalErrors from "../../../../components/user/ModalErrors";
import thTH from "antd/lib/locale-provider/th_TH";
import { WatDatePicker } from "thaidatepicker-react";
import axiosAPI from "../../../../config/axiosAPI";
import { MEETING_RESPONSE_STATUS } from '../../../../utils/constants';

const { Option } = Select;
const { TextArea } = Input;
const { Text } = Typography;
const TIME_FORMAT = "HH:mm น.";
const MEETING_STATUS = {
    WAITING_APPROVE: "WaitingApprove",
    EDIT_APPROVE: "EditApprove"
}

class CustomizedForm extends React.Component{}
class CreateMeetingForm extends React.Component {
   formRef = Form.create();

    state = {
        idMeeting: null,
        showModalConfirm: false,
        showModalSave: false,
        showModalSureInternal: false,
        showModalSureExternal: false,
        textModalSuccess: "",
        showModalSuccess: false,
        showModallistInviteInternal: false,
        showModallistInviteExternal: false,
        showModalDeleteMeeting: false,
        showModalConfirmDelete: false,
        showModalDeleteInviteExternal: false,
        showModalDeleteInviteInternal: false,
        textModalDelete: "",
        showModalConfirmFail: false,
        showModalSelectAprover: false,
        listInviteInternal: [],
        listInviteInternalModal: [],
        AddInviteInternal: [],
        inviteInternal: [],
        countInviteInternal: 0,
        listInviteExternal: [],
        showlistInviteExternal: [],
        listDeleteInviteExternal: [],
        listDeleteInviteExternalAll: [],
        listDeleteInviteInternal: [],
        inviteExternal: [],
        countInviteExternal: 0,
        countInviteExternalAll: 0,
        conutInviteExternalAccept: 0,
        countAddBlock: 1,
        fromPage: "/meetingmanagement/createMeeting",
        approve: "no",
        approverList: [],
        approverListSearch: [],
        approverSelect: null,
        selectApprover: [],
        dropdownOrg: [],
        dropdownDivision: [],
        dropdownDepartment: [],
        uploadFile: [],
        limitpaginateGuset: 10,
        totalpaginateGuset: 0,
        currentPaginateGuset: 1,
        dataMeeting: "",
        ApproverDetail: "",
        OrganizerDetail: "",
        GuestsInvite: "",
        OtherGuestsInvite: "",
        preload: "",
        NameExternal: "",
        dataForm: {
            id: null,
            approverID: null,
            approverName: null,
            subject: null,
            documentDate: null,
            location: null,
            startDate: moment().locale("th"),
            startTime: null,
            endDate: null,
            endTime: null,
            Guests: null,
            OtherGuests: null,
            detail: null,
            meetingURL: null,
            Attacheds: null,
        },
        fileList: [],
        searchNameInternal: "",
        groupCode: "",
        orgCode: "",
        valueSelectOrg: "",
        valueSelectDep: "",
        valueSelectDiv: "",
        dropdownGroup: [],
        AttachedInactive: [],
        OrgJoinMeeting: false,
        loadingFullpage: false,
        loadingInternal: false,
        isCheckExternal: [],
        isCheckInternal: [],
        isEditExternal: false,
        disableOther: false,
        disableGroup: false,
        isSearch: false,
        statusMeeting: null,
        approverSearchInput: "",
        approverSearchDropdown: "",
        approverSelected: null,
    };

    componentDidMount = async () => {
        const queryString = require("query-string");
        const parsed = queryString.parse(this.props.location.search);
        if (parsed.from) await this.setState({ fromPage: parsed.from });
        if (parsed.approve) await this.setState({ needApprove: parsed.approve });
        if (parsed.note) await this.setState({ needNote: parsed.note });
        if (parsed.status) this.setState({ statusMeeting: parsed.status });
        if (parsed.id) {
            axiosAPI.post(`${UrlMeeting()}/meeting/secure/meetingdetail`, {
                    MeetingID: parsed.id,
                })
                .then(async (response) => {
                   console.log("responsresponsee", response)
                    const data = response.data.status.message;
                    const isJoin = data[0].Guests.some(
                        (o) => o.userID === data[0].organizerID
                    );
                    const guests = data[0].Guests.filter(
                        (o) => o.userID != sessionStorage.getItem("username")
                    );

                    await this.setState({
                        OrgJoinMeeting: isJoin,
                        dataMeeting: data[0] ? data[0] : [],
                        ApproverDetail: data[1].ApproverDetail
                            ? data[1].ApproverDetail
                            : [],
                        OrganizerDetail: data[1].OrganizerDetail
                            ? data[1].OrganizerDetail
                            : [],
                        GuestsInvite: guests,
                        OtherGuestsInvite: data[0].OtherGuests ? data[0].OtherGuests : [],
                        preload: false,
                        dataForm: {
                            id: data[0].id,
                            subject: data[0].subject,
                            documentDate: moment(data[0].documentDate),
                            location: data[0].location,
                            startDate: moment(data[0].startDate),
                            startTime: moment(data[0].startDate),
                            endDate: moment(data[0].endDate),
                            endTime: moment(data[0].endDate),
                            Guests: data[0].Guests,
                            OtherGuests: data[0].OtherGuests,
                            detail: data[0].detail,
                            meetingURL: data[0].meetingURL,
                            Attacheds: data[0].Attacheds,
                            approverID: data[0]?.approveID || "",
                            approverName: data[1]?.ApproverDetail
                                ? data[1]?.ApproverDetail.title +
                                " " +
                                data[1]?.ApproverDetail.firstName +
                                " " +
                                data[1]?.ApproverDetail.lastName
                                : "",
                        },
                        fileList: data[0].Attacheds,
                    });
                    guests.forEach((element) => {
                        this.setState({
                            listInviteExternal: [
                                ...this.state.listInviteExternal,
                                {
                                    ...element,
                                    code: element.userID,
                                    empCode: element.userID,
                                    name:
                                        element.title +
                                        " " +
                                        element.firstName +
                                        " " +
                                        element.lastName,
                                },
                            ],
                            showlistInviteExternal: [
                                ...this.state.showlistInviteExternal,
                                {
                                    ...element,
                                    code: element.userID,
                                    empCode: element.userID,
                                    name:
                                        element.title +
                                        " " +
                                        element.firstName +
                                        " " +
                                        element.lastName,
                                },
                            ],
                        });
                    });
                    data[0].OtherGuests.forEach((element, index) => {
                        this.setState({
                            listInviteInternal: [
                                ...this.state.listInviteInternal,
                                {
                                    code: index + 1,
                                    Name: element.name,
                                    Email: element.email,
                                    asRole: element.asRole,
                                    // Status: element.isStatusResponse,
                                    Status: parseInt(element.asRole),
                                },
                            ],
                        });
                    });

                    const countAcceptOther = data[0].OtherGuests.filter(
                        (o) => o.asRole === "1"
                    );
                    this.setState({
                        idMeeting: parsed.id,
                        // needApprove: data[1].OrganizerDetail,
                        countInviteInternal: this.state.listInviteExternal.length,
                        countInviteExternal: this.state.listInviteInternal.length,
                        countInviteExternalAll: this.state.listInviteInternal.length,
                        conutInviteExternalAccept: countAcceptOther.length,
                    });
                })
                .catch((error) => console.error(`Error: ${error}`));
        }
        this.fetchListOrg();
        this.fetchListGroup();

        axiosAPI.get(`${UrlMeeting()}/meeting/secure/approver/listApprover`)
            .then((response) => {
                const data = response.data.listApproverDataRs;
                data.forEach((element) => {
                    this.setState({
                        approverList: [
                            ...this.state.approverList,
                            {
                                id: element.empCode,
                                name:
                                    element.title +
                                    " " +
                                    element.firstName +
                                    " " +
                                    element.lastName,
                                orgCode: element.orgCode,
                            },
                        ],
                        approverListSearch: [
                            ...this.state.approverList,
                            {
                                id: element.empCode,
                                name:
                                    element.title +
                                    " " +
                                    element.firstName +
                                    " " +
                                    element.lastName,
                                orgCode: element.orgCode,
                            },
                        ],
                    });
                });
            })
            .catch((error) => console.error(`Error: ${error}`));
        await this.setState({
            countInviteInternal: this.state.listInviteExternal.length,
            countInviteExternal: this.state.inviteExternal.length,
        });
    };
    fetchListGroup = () => {
        axiosAPI.get(`${UrlMeeting()}/meeting/secure/group/listgroupmeetingall`)
            .then((response) => {
                const data = response.data;
                this.setState({
                    dropdownGroup: data,
                });
            })
            .catch((error) => console.error(`Error: ${error}`));
    };
    fetchListOrg = () => {
        axiosAPI.get(`${UrlMeeting()}/meeting/secure/finddropdownbyorg/org/`)
            .then((response) => {
                const data = response.data.status.message.fetchListOrgForTwoway;
                this.setState({
                    dropdownOrg: data,
                });
            })
            .catch((error) => console.error(`Error: ${error}`));
    };
    fetchListDiv = (id) => {
        axiosAPI.get(
                `${UrlMeeting()}/meeting/secure/finddropdownbyorg/division/?id=${id}`
            )
            .then((response) => {
                const data = response.data.status.message.fetchListDivisionForTwoway;
                this.setState({
                    dropdownDivision: data,
                });
            })
            .catch((error) => console.error(`Error: ${error}`));
    };
    fetchListDep = (id) => {
        axiosAPI.get(
                `${UrlMeeting()}/meeting/secure/finddropdownbyorg/department/?id=${id}`
            )
            .then((response) => {
                const data = response.data.status.message.fetchListDepartmentForTwoway;
                this.setState({
                    dropdownDepartment: data,
                });
            })
            .catch((error) => console.error(`Error: ${error}`));
    };
    handleOpen = () => {
        this.setState({
            showModalConfirm: true,
        });
    };

    handleOpenSave = () => {
        this.setState({
            showModalSave: true,
        });
    };

    handleOkSaveInternalSuccess = () => {
        this.setState({
            showModalSave: false,
            textModalSuccess: "ส่งคำเชิญประชุมเรียบร้อย",
            showModallistInviteInternal: false,
            showModalSureInternal: false,
            showModalSuccess: true,
            dropdownGroup: [],
        });
        setTimeout(() => {
            this.setState({
                showModalSuccess: false,
            });
        }, 1000);
    };
    handleOkSaveExternal = () => {

        const validateEmail = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-z]+){2,}$/
        const isEmpty = this.state.AddInviteInternal.some((o) => {
            if (!o.Name || o.Name === "" || !o.Email || o.Email === "") {
                return true
            } else {
                if (validateEmail.test(o.Email)) {
                    return false
                } else {
                    return true
                }
            }
        });

        let countAccept = 0;
        if (this.state.listInviteInternal.length > 0) {
            countAccept =
                countAccept +
                this.state.listInviteInternal.filter((o) => o.Status === MEETING_RESPONSE_STATUS.JOIN).length;
        }
        countAccept =
            countAccept +
            this.state.AddInviteInternal.filter((o) => o.Status === MEETING_RESPONSE_STATUS.JOIN).length;
        if (isEmpty) {
            //alert
        } else {
            this.setState({
                listInviteInternal: [
                    ...this.state.listInviteInternal,
                    ...this.state.AddInviteInternal,
                ],
                countInviteExternal:
                    this.state.listInviteInternal.length +
                    this.state.AddInviteInternal.length,
                countInviteExternalAll:
                    this.state.countInviteExternalAll +
                    this.state.AddInviteInternal.length,
                conutInviteExternalAccept: countAccept,
                countAddBlock: 1,
                showModallistInviteExternal: false,
                AddInviteInternal: [],
                isCheckExternal: [],
                listDeleteInviteInternal: [],
            });
        }
    };
    handleSaveEditExternal = () => {
        const mapListEdit = this.state.listInviteInternal.map((data) => {
            const findEdit = this.state.AddInviteInternal.find(
                (o) => o.code === data.code
            );
            if (findEdit) {
                data = findEdit;
            }
            return data;
        });

        const validateEmail = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-z]+){2,}$/
        const isEmpty = mapListEdit.some((o) => {
            if (!o.Name || o.Name === "" || !o.Email || o.Email === "") {
                return true
            } else {
                if (validateEmail.test(o.Email)) {
                    return false
                } else {
                    return true
                }
            }
        });

        if (isEmpty) {
            //alert
        } else {
            const countAccept = mapListEdit.filter((o) => o.Status === MEETING_RESPONSE_STATUS.JOIN).length;

            this.setState({
                listInviteInternal: mapListEdit,
                countAddBlock: 1,
                conutInviteExternalAccept: countAccept,
                showModallistInviteExternal: false,
                AddInviteInternal: [],
                listDeleteInviteInternal: [],
                isCheckExternal: [],
                isEditExternal: false,
            });
        }
    };

    handleOkSaveExternalSuccess = () => {
        this.setState({
            listInviteInternal: this.state.AddInviteInternal,
            showModalSave: false,
            textModalSuccess: "ส่งคำเชิญประชุมเรียบร้อย",
            showModallistInviteExternal: false,
            showModalSureExternal: false,
            showModalSuccess: true,
        });
        setTimeout(() => {
            this.setState({
                showModalSuccess: false,
            });
        }, 1000);
    };

    handleCancel = () => {
        this.setState({
            showModalConfirm: false,
            showModalSureExternal: false,
            showModallistInviteInternal: false,
            showModallistInviteExternal: false,
            showModalSuccess: false,
            showModalSureInternal: false,
            showModalSave: false,
            showModalDeleteInviteExternal: false,
            showModalDeleteInviteInternal: false,
            showModalConfirmFail: false,
            showModalDeleteMeeting: false,
            showModalConfirmDelete: false,
            showModalSelectAprover: false,
            inviteInternal: [],
            totalpaginateGuset: 0,
            countAddBlock: 1,
            isEditExternal: false,
            showModallistInviteExternal: false,
            showlistInviteExternal: [],
            AddInviteInternal: [],
            disableOther: false,
            groupCode: "",
            orgCode: "",
            valueSelectOrg: "",
            valueSelectDiv: "",
            valueSelectDep: "",
            searchNameInternal: "",
            dropdownDivision: [],
            dropdownDepartment: [],
            isSearch: false,
            loadingInternal: false,
            approverSearchInput: "",
            approverSearchDropdown: "",
            approverSelected: null,
        });
    };

    openModalAddInternal = () => {
        this.setState({
            showModallistInviteInternal: true,
        });
    };

    openModalAddExternal = () => {
        this.setState({
            showModallistInviteExternal: true,
        });
    };

    handleOk = async () => {
        await this.handleSubmit("submit");
    };
    handleOkSaveDraft = async () => {
        await this.handleSubmit("save");
        this.setState({
            showModalSave: false
        })
    };

    addExternalCount = () => {
        this.setState({
            countAddBlock: this.state.countAddBlock + 1,
        });
    };

    fetchListUser = (groupCode, orgcode, limit, offset, input) => {
         this.setState({ 
           loadingInternal: true 
         });

        axiosAPI.get(
                `${UrlMeeting()}/meeting/secure/searchemployee?groupID=${groupCode}&orgCode=${orgcode}&limit=${limit}&offset=${offset}&search=${input}`
            )
            .then((response) => {
                const data =
                    response.data.status.message.searchEmployeeByEmpCodesAndOrgCode;

               console.log("responresponsese" , data)
               console.log("responresponsese" , data.totalPage)
                this.setState({
                    inviteInternal: data.data,
                    totalpaginateGuset: data.total,
                    isSearch: true,
                    loadingInternal: false,
                });

                let item = document.getElementsByClassName("checkbox-listInviteInternal")

                for (let i = 0; i < item.length; i++) {
                  console.log("pagxxxxe", item[i].getElementsByClassName("ant-checkbox"));
                  item[i].getElementsByClassName("ant-checkbox")[0].classList.remove('ant-checkbox-checked');
         
                }
            })
            .catch((error) => {
                this.setState({
                    isSearch: true,
                    loadingInternal: false,
                });
                console.error(`Error: ${error}`);
            });
    };

    ChangeTextSearch = (value) => {
        this.setState({
            searchNameInternal: value.target.value,
        });
    };
    ChangeGroup = (value) => {
        if (value) {
            this.setState({
                groupCode: value,
                disableOther: true,
            });
        } else {
            this.setState({
                groupCode: "",
                disableOther: false,
            });
        }
    };
    ChangeOrg = (value) => {
        if (value) {
            this.setState({
                orgCode: value,
                valueSelectOrg: value,
                valueSelectDiv: "",
                valueSelectDep: "",
                dropdownDivision: [],
                dropdownDepartment: [],
                disableGroup: true,
            });

            this.fetchListDiv(value);
        } else {
            this.setState({
                orgCode: "",
                valueSelectOrg: "",
                valueSelectDiv: "",
                valueSelectDep: "",
                dropdownDivision: [],
                dropdownDepartment: [],
                disableGroup: false,
            });
        }
    };
    ChangeDiv = (value) => {
        if (value) {
            this.setState({
                orgCode: value,
                valueSelectDiv: value,
                valueSelectDep: "",
                dropdownDepartment: [],
                disableGroup: true,
            });

            this.fetchListDep(value);
        } else {
            this.setState({
                orgCode: "",
                valueSelectDiv: "",
                valueSelectDep: "",
                dropdownDepartment: [],
                disableGroup: false,
            });
        }
    };
    ChangeDep = (value) => {
        if (value) {
            this.setState({
                orgCode: value,
                valueSelectDep: value,
                disableGroup: true,
            });
        } else {
            this.setState({
                orgCode: "",
                valueSelectDep: "",
                disableGroup: false,
            });
        }
    };
    onChangePage = (page) => {
        this.setState({
            currentPaginateGuset: page,
        });

       let item = document.getElementsByClassName("checkbox-listInviteInternal")

       for (let i = 0; i < item.length; i++) {
         console.log("pagxxxxe", item[i].getElementsByClassName("ant-checkbox"));
         item[i].getElementsByClassName("ant-checkbox")[0].classList.remove('ant-checkbox-checked');
       }
      //   console.log("pagxxxxe", item.getElementsByClassName("ant-checkbox-input"))
        this.fetchListUser(
            this.state.groupCode,
            this.state.orgCode,
            this.state.limitpaginateGuset,
            (page-1) * this.state.limitpaginateGuset,
            this.state.searchNameInternal,
            true
        );
    };

    confirmSearch = () => {
         this.setState({
            currentPaginateGuset: 1,
         });


        const orgCode = this.state.valueSelectDep
                ? this.state.valueSelectDep
                : this.state.valueSelectDiv
                    ? this.state.valueSelectDiv
                    : this.state.valueSelectOrg;

        this.fetchListUser(
            this.state.groupCode,
            orgCode,
            this.state.limitpaginateGuset,
            0,
            this.state.searchNameInternal
        );
    };
    onCheckAddInternal = async (e, user) => {
       console.log("userxxxxxx", e)
        if (e.target.checked) {
            await this.setState({
                showlistInviteExternal: [
                    ...this.state.showlistInviteExternal,
                    { ...user, code: e.target.value, name: user.title+user.firstName+' '+user.lastName },
                ],
            });

            // {user.title} {user.firstName} {user.lastName}
        } else {
            const newshowlistInviteExternal =
                this.state.showlistInviteExternal.filter(
                    (element) => element.code != e.target.value
                );
            await this.setState({
                showlistInviteExternal: newshowlistInviteExternal,
            });
        }
    };

    handleOkSaveInternal = async () => {
        let newList = this.state.showlistInviteExternal;

        if (this.state.listInviteExternal.length > 0) {
            newList = newList.filter(
                (f) => !this.state.listInviteExternal.some((s) => s.empCode === f.empCode)
            );
        }

        await this.setState({
            listInviteExternal: [...this.state.listInviteExternal, ...newList],
            countInviteInternal:
                this.state.listInviteExternal.length + newList.length,
            showlistInviteExternal: [],
            showModalSave: false,
            textModalSuccess: "ส่งคำเชิญประชุมเรียบร้อย",
            showModallistInviteInternal: false,
        });

        this.handleCancel();
    };
    onCheckDeleteInternal = async (e, index) => {
        if (e.target.checked) {
            await this.setState({
                listDeleteInviteExternal: [
                    ...this.state.listDeleteInviteExternal,
                    {
                        code: e.target.value,
                        name: e.target.name,
                        index: index + 1,
                    },
                ].sort((a, b) => a.index - b.index),
            });
        } else {
            const newlistInviteExternal = this.state.listDeleteInviteExternal.filter(
                (element) => element.code != e.target.value
            );
            await this.setState({ listDeleteInviteExternal: newlistInviteExternal });
        }
    };

    onCheckDeleteExternal = async (e, index) => {
        const findlist = this.state.listInviteInternal.find(
            (o) => o.code === e.target.value
        );

        if (e.target.checked) {
            await this.setState({
                listDeleteInviteInternal: [
                    ...this.state.listDeleteInviteInternal,
                    {
                        ...findlist,
                        index: index + 1,
                    },
                ].sort((a, b) => a.index - b.index),
            });
        } else {
            const newlistInviteInternal = this.state.listDeleteInviteInternal.filter(
                (element) => element.code != e.target.value
            );
            await this.setState({ listDeleteInviteInternal: newlistInviteInternal });
        }
    };
    openModalDeleteMeeting = () => {
        this.setState({
            showModalDeleteMeeting: true,
        });
    };
    handleOkDeleteMeeting = () => {
        this.setState({
            showModalDeleteMeeting: false,
            textModalDelete: "ปฏิเสธการประชุม",
            showModalConfirmDelete: true,
        });
        setTimeout(() => {
            this.setState({
                showModalConfirmDelete: false,
            });
        }, 1000);
    };

    openModalDeleteInviteExternal = () => {
        this.setState({
            showModalDeleteInviteExternal: true,
        });
    };
    openModalDeleteInviteInternal = () => {
        this.setState({
            showModalDeleteInviteInternal: true,
        });
    };

    openModalEditExternal = () => {
        this.setState({
            isEditExternal: true,
            countAddBlock: this.state.countInviteExternal,
            showModallistInviteExternal: true,
            AddInviteInternal: this.state.listDeleteInviteInternal,
        });
    };

    handleOkDeleteInviteExternal = async () => {
        let newlistInviteExternal = null;
        let deleteUserCode = [];

        this.state.listDeleteInviteExternal.forEach((deleteUser) => {
            deleteUserCode.push(deleteUser.code);
        });

        newlistInviteExternal = this.state.listInviteExternal.filter(
            (element) => !deleteUserCode.includes(element.code)
        );

        this.setState({
            listInviteExternal: newlistInviteExternal,
            countInviteInternal: newlistInviteExternal.length,
            listDeleteInviteExternal: [],
            showModalDeleteInviteExternal: false,
            textModalDelete: "ลบผู้เข้าร่วมออกจากการประชุมเรียบร้อย",
            showModalConfirmFail: true,
        });
        setTimeout(() => {
            this.setState({
                showModalConfirmFail: false,
            });
        }, 1000);
    };

    handleOkDeleteInviteInternal = async () => {
        let newlistInviteInternal = null;
        let deleteUserCode = [];

        this.state.listDeleteInviteInternal.forEach((deleteUser) => {
            deleteUserCode.push(deleteUser.code);
        });

        newlistInviteInternal = this.state.listInviteInternal.filter(
            (element) => !deleteUserCode.includes(element.code)
        );
        const countAccept = newlistInviteInternal.filter((e) => e.Status === MEETING_RESPONSE_STATUS.JOIN);
        // const newlistInviteInternal = this.state.listDeleteInviteInternal.filter(element => element.code != e.target.value);
        this.setState({
            listDeleteInviteExternalAll: [
                ...this.state.listDeleteInviteExternalAll,
                ...deleteUserCode,
            ],
            listInviteInternal: newlistInviteInternal,
            countInviteExternal: newlistInviteInternal.length,
            conutInviteExternalAccept: countAccept.length,
            listDeleteInviteInternal: [],
            showModalDeleteInviteInternal: false,
            textModalDelete: "ลบผู้เข้าร่วมออกจากการประชุมเรียบร้อย",
            showModalConfirmFail: true,
        });
        setTimeout(() => {
            this.setState({
                showModalConfirmFail: false,
            });
        }, 1000);
    };

    handleSelectApprover = () => {
        this.setState({
            showModalSelectAprover: true,
            approverListSearch: this.state.approverList
        });
    };
    handleOkapproverList = () => {
        this.setState({
            dataForm: {
                ...this.state.dataForm,
                approverID: this.state.approverSelected.id,
                approverName: this.state.approverSelected.name,
            },
            showModalSelectAprover: false,
        });
        this.props.form.setFieldsValue({
            approverID: this.state.approverSelected.name
        });
    };

    onCheckSelect = async (e) => {
        let temp = e.target.value;
        temp = temp.split("/");
        this.setState({
            approverSelected: { id: temp[0], name: temp[1] },
        });
    };

    checkRequireField = (data) => {
        if (
            data.subject &&
            data.documentDate &&
            data.startDate &&
            data.startTime &&
            data.endDate &&
            data.endTime &&
            data.detail
        ) {
            if (this.state.needApprove === "yes") {
                if (this.state.dataForm.approverID) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        } else {
            return false;
        }
    };

    handleSubmit = async (submit) => {
        this.setState({ showModalConfirm: false });
        const { form, afterSubmit, client } = this.props;
        const { dataForm, AttachedInactive, MeetingID, statusMeeting, dataMeeting } = this.state;
        form.validateFields(async (err, values) => {
            const fieldValues = {
                subject: values["subject"],
                documentDate: values["documentDate"],
                approverID: values["approverID"],
                location: values["location"],
                startDate: values["startDate"],
                startTime: values["startTime"],
                endDate: values["endDate"],
                endTime: values["endTime"],
                detail: values["detail"],
                meetingURL: values["meetingURL"],
            };

            const isPass = this.checkRequireField(fieldValues);

            if (isPass) {
                // this.setState({ loadingFullpage: true });

                const startDateTime =
                    moment(fieldValues.startDate).format("YYYY-MM-DD") +
                    " " +
                    moment(fieldValues.startTime).format("HH:mm:mm.663");
                const endDateTime =
                    moment(fieldValues.endDate).format("YYYY-MM-DD") +
                    " " +
                    moment(fieldValues.endTime).format("HH:mm:mm.663");
                const documentDateTime = moment(fieldValues.documentDate).format(
                    "YYYY-MM-DD HH:mm:ss.663"
                );

                let RedcrossGuest = [];
                const userID = sessionStorage.getItem("username");

                if (this.state.OrgJoinMeeting) {
                    RedcrossGuest.push({ UserID: userID });
                }

                this.state.listInviteExternal.forEach((element) => {
                    RedcrossGuest.push({ UserID: element.code });
                });

                const listExternal = this.state.listInviteInternal.map((o) => {
                    if (!o.Status) {
                        o.Status = MEETING_RESPONSE_STATUS.WAITTING;
                    }
                    return o;
                });

                let dataParam = {
                    APIKey: "D6874861-B6C8-49AD-AD2C-B56BFF4065A8",
                    RequireApprove: this.state.needApprove === "yes",
                    Draft: submit !== "submit",
                    RequireMeetingSummary: this.state.needNote === "yes",
                    Subject: fieldValues.subject,
                    Location: fieldValues.location,
                    Detail: fieldValues.detail,
                    documentDate: documentDateTime,
                    startDatetime: startDateTime,
                    EndDatetime: endDateTime,
                    RedcrossGuest: RedcrossGuest,
                    OtherGuest: listExternal,
                    OrganizerID: userID,
                    ApproverID: this.state.dataForm.approverID,
                    MeetingURL: fieldValues.meetingURL,
                };

             
                if (dataForm.id && statusMeeting != "success") {
                  dataParam.OrganizerID = dataMeeting.organizerID
                  dataParam.RedcrossGuest = dataParam.RedcrossGuest.filter(valueObj => valueObj.UserID !== this.state.dataForm.approverID) 
                  const statusApprove = 'approveafteredit';

                    if (statusMeeting === MEETING_STATUS.EDIT_APPROVE) {
                        dataParam = {
                            ...dataParam,
                            MeetingID: dataForm.id,
                            AttachedInactive,
                            AttachedNew: this.state.uploadFile,
                        };
                        axiosAPI.post(`${UrlMeeting()}/meeting/secure/updateMeeting`, {
                                ...dataParam,
                            })
                            .then((response) => {
                              axiosAPI.post(`${UrlMeeting()}/meeting/secure/approveMeeting`, {
                                        UserID: sessionStorage.getItem("username"),
                                        MeetingID: dataForm.id,
                                        Status: statusApprove,
                                        Remark: "",
                                    })
                                    .then((response) => {
                                        this.setState({
                                            loadingFullpage: false,
                                            textModalSuccess: "บันทึกการแก้ไขและอนุมัติสร้างการประชุมเรียบร้อย",
                                            showModalSuccess: true,
                                        });

                                        setTimeout(async () => {
                                            this.setState({
                                                showModalSuccess: false,
                                            });
                                            this.handleCancel();
                                            this.props.history.goBack()
                                        }, 1500)

                                    })
                                    .catch((error) => {
                                        this.setState({ loadingFullpage: false });
                                        console.error(`Error: ${error}`);
                                    });
                            })
                            .catch((error) => {
                                this.setState({ loadingFullpage: false });
                                console.error(`Error: ${error}`);
                            });
                    } else {
                        dataParam = {
                            ...dataParam,
                            MeetingID: dataForm.id,
                            AttachedInactive,
                            AttachedNew: this.state.uploadFile,
                        };
                        axiosAPI.post(`${UrlMeeting()}/meeting/secure/updateMeeting`, {
                                ...dataParam,
                            })
                            .then(async (response) => {
                                this.setState({ loadingFullpage: false });
                                this.setState({
                                    textModalSuccess:
                                        statusMeeting === MEETING_STATUS.WAITING_APPROVE
                                            ? "บันทึกการแก้ไข รายการขออนุมัติเรียบร้อย"
                                            : "ส่งคำเชิญประชุมสำเร็จ",
                                    showModalSuccess: true,
                                });

                                if (statusMeeting === MEETING_STATUS.WAITING_APPROVE) {

                                    setTimeout(async () => {
                                        this.setState({
                                            showModalSuccess: false,
                                        });
                                        this.handleCancel();
                                        this.props.history.goBack()
                                    }, 1500)

                                } else {

                                    setTimeout(() => {
                                        this.setState({
                                            showModalSuccess: false,
                                        });
                                        this.handleCancel();
                                        window.location.href = "/meetingmanagement/createMeeting"
                                    }, 1500)

                                }
                            })
                            .catch((error) => {
                                this.setState({ loadingFullpage: false });
                                console.error(`Error: ${error}`);
                            });
                    }
                } else {
                    dataParam = { ...dataParam, Attached: this.state.uploadFile };

                    axiosAPI.post(`${UrlMeeting()}/meeting/secure/meeting/addNewMeeting`, {
                            ...dataParam,
                        })
                        .then(async (response) => {
                            this.setState({ loadingFullpage: false });

                            this.setState({
                                showModalConfirm: false,
                                textModalSuccess: submit === "submit" ? "ส่งคำเชิญประชุมสำเร็จ" : `บันทึกเป็นการประชุม\nฉบับร่างเรียบร้อย`,
                                showModalSuccess: response.data.msg ? false : true,
                            });

                            if (statusMeeting === "success") {

                                setTimeout(() => {
                                    this.setState({
                                        showModalSuccess: false,
                                    });
                                    this.handleCancel();
                                    window.location.href = "/meetingmanagement/createMeeting"
                                }, 1500)

                            } else {

                                setTimeout(() => {
                                    this.setState({
                                        showModalSuccess: false,
                                    });
                                    this.handleCancel();
                                    this.props.history.goBack()
                                }, 1500)

                            }
                        })
                        .catch((error) => {
                            this.setState({ loadingFullpage: false });
                            console.error(`Error: ${error}`);
                        });
                }
            }
        });
    };

    onChangeModalExternal = async (values, codeId, typeName) => {
        const { AddInviteInternal } = this.state;
        let dataSourceitems = [...this.state.listInviteInternalModal];
        dataSourceitems.map((valuesSate, keys) => {
            if (valuesSate.code === codeId) {
                if (typeName === "name") {
                    valuesSate.Name = values;
                } else if (typeName === "email") {
                    valuesSate.Email = values;
                } else if (typeName === "Status") {
                    valuesSate.Status = values;
                }
            }
        });

        this.setState(
            {
                listInviteInternalModal: dataSourceitems,
            },
            async () => {
                // await this.setSummary()
                // this.cllBackSetValueContactNumber()
            }
        );
    };

    onChangeNameOrEmailExternal = async (attendees, countId) => {
        const { AddInviteInternal } = this.state;
        let temp = AddInviteInternal;
        let found = AddInviteInternal.find(
            (element) => element.code === countId
        );
        if (found) {
            const newArr = AddInviteInternal.map((obj) => {
                if (obj.code === countId) {
                    return { ...obj, Name: attendees[countId].Name, Email: attendees[countId].Email }
                } else {
                    return obj;
                }
            });
            temp = newArr;
        } else {
            temp.push({ code: countId, Name: attendees[countId].Name, Email: attendees[countId].Email });
        }
        this.setState({ AddInviteInternal: temp });
    };

    onChangeSwitchExternal = async (e, id) => {
        const { AddInviteInternal } = this.state;
        let temp = AddInviteInternal;
        let found = AddInviteInternal.find((element) => element.code === id);
        if (found) {
            // console.log("tetempmp found :", objectReturn)
            const newArr = AddInviteInternal.map((obj) => {
               let objectReturn = {
                  Status: e ? MEETING_RESPONSE_STATUS.JOIN : MEETING_RESPONSE_STATUS.WAITTING,
                }
                if (obj.code === id) {
                     if(obj.asRole){
                        objectReturn = {
                           ...objectReturn,
                           asRole: e ? "2" : "1"
                        }
                     }

                console.log("countBlock", objectReturn)
                       return { 
                       ...obj, 
                       ...objectReturn
                     //   Status: e ? MEETING_RESPONSE_STATUS.JOIN : MEETING_RESPONSE_STATUS.WAITTING,
                     //   asRole: obj.asRole ? e ? "2" : "1"  : null
                     };
                } else {
                    return obj;
                }
            });
            console.log("countBlock newArr", newArr)

            temp = newArr;
        } else {
            console.log("tetempmp else :", temp)
            temp.push({ 
               code: id, 
               Status: e ? MEETING_RESPONSE_STATUS.JOIN : MEETING_RESPONSE_STATUS.WAITTING 
            });
        }
        this.setState({ AddInviteInternal: temp });
    };

    convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    checkFileType = (typeFile) => {
        if ([".presentationml.presentation", "application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.slideshow", "application/vnd.openxmlformats-officedocument.presentationml.presentation"].includes(typeFile)) {
            return "ppt";
        } else if ([".spreadsheetml.sheet", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"].includes(typeFile)) {
            return "excel";
        } else if ([".wordprocessingml.document", "application/msword", ".doc", ".docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"].includes(typeFile)) {
            return "words";
        } else if (["application/pdf"].includes(typeFile)) {
            return "PDF";
        } else if (["image/png"].includes(typeFile)) {
            return "png";
        } else if (["image/jpeg"].includes(typeFile)) {
            return "jpg"
        } else if (["application/zip", "application/x-zip-compressed", "multipart/x-zip"].includes(typeFile)) {
            return "zip"
        }
    };


    changeHandler = async (event) => {
        if (event?.target?.files && event?.target?.files[0]) {

            if (![
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-excel",
                ".doc",
                ".docx",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/pdf",
                "application/vnd.ms-powerpoint",
                "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
                "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                "image/png",
                "image/jpeg",
                "application/zip",
                "application/x-zip-compressed",
                "multipart/x-zip"].includes(event.target.files[0].type)) {
                return false;
            }

            let fileList = this.state.fileList;
            let uploadFile = this.state.uploadFile;
            fileList.push(event.target.files[0]);
            let FileName = event.target.files[0].name;
            let FileType = this.checkFileType(event.target.files[0].type);
            const FileData = await this.convertBase64(event.target.files[0]);
            uploadFile.push({ FileName, FileType, FileData });

            this.setState({
                fileList,
                uploadFile,
            });
        }

    };

    handleSubmission = () => { };

    destroyFileList = async (arrayId, fileId = null) => {
        const { fileList, AttachedInactive } = this.state;
        var arrayDataSource = [...this.state.fileList];
        var AddAttachedInactive = AttachedInactive;
        arrayDataSource.splice(arrayId, 1);

        var arrayDataSourceUploadFile = [...this.state.uploadFile];
        arrayDataSourceUploadFile.splice(arrayId, 1);

        if (fileId) {
            var arrayObjectPush = {
                attachID: fileId,
            };
            AddAttachedInactive.push(arrayObjectPush);
        }

        this.setState(
            {
                fileList: arrayDataSource,
                uploadFile: arrayDataSourceUploadFile,
                AttachedInactive: AddAttachedInactive,
            },
            async () => { }
        );
    };

    modalShowFileCreate = async (dataFile, title) => {
        var url = URL.createObjectURL(dataFile);
        const reader = new FileReader();
        if (dataFile.type !== "application/pdf") {
            reader.readAsDataURL(dataFile);
            reader.onloadend = async (e) => {
                var dataURL = reader.result;
                this.setState({
                    linkNewTab: dataURL,
                });

                this.onClickToNewTab(dataURL, dataFile.type);
            };
        } else {
            reader.readAsDataURL(dataFile);
            reader.onloadend = async (e) => {
                var dataURL = reader.result;
                this.setState({
                    linkNewTab: dataURL,
                });

                this.onClickToNewTab(dataURL, dataFile.type);
            };
        }
    };

    onClickToNewTab = (dataURL, typeFile) => {
        const { linkNewTab } = this.state;
        // if(typeFile !== "application/pdf"){
        //       var win = window.open();
        //       win.document.write('<div style="margin:0 auto; width:900px; max-width:900px" align="center"><img src="' + dataURL  + '" style="max-width:100%;height:100%"/></div>');
        // }else{
        var win = window.open();
        win.document.write(
            '<iframe src="' +
            dataURL +
            '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
        );
        // }
    };

    onChangeSearchApproverList = async (values, orgCode = "", isDropdown = false) => {
        console.info('approvers: ', values, orgCode, isDropdown)
        const { approverList, approverSearchDropdown, approverSearchInput } = this.state;

        if (isDropdown) {
            this.setState({
                approverSearchDropdown: orgCode,
                approverSelected: null,
            });
        } else {
            this.setState({
                approverSearchInput: values,
                approverSelected: null,
            });
        }

        if (!isDropdown) {

            let results = approverList
            if (approverSearchDropdown) {
                results = approverList.filter((data) => data.orgCode === approverSearchDropdown)
            }

            if (values) {
                results = results.filter((data) => {
                    return Object.keys(data).some((key) => 
                        data[key] !== null ? data[key].includes(values) : false
                    );
                });
                this.setState({
                    approverListSearch: results,
                });
            } else {
                this.setState({
                    approverListSearch: results,
                });
            }
        } else if (isDropdown) {

            let results = approverList
            if (orgCode) {
                results = approverList.filter((data) => data.orgCode === orgCode)
            }

            if (approverSearchInput) {
                results = results.filter((data) => {
                    return Object.keys(data).some((key) =>
                        data[key].includes(approverSearchInput)
                    );
                });
                this.setState({
                    approverListSearch: results,
                });
            } else {
                this.setState({
                    approverListSearch: results,
                });
            }
        } else {
            this.setState({
                approverListSearch: approverList,
            });
        }

    };
    JoinMeeting = async (e) => {
        this.setState({ OrgJoinMeeting: e });
    };

    disabledDateStart = (current) => {
        return current && current < moment().startOf("day");
    };

    disableDateRanges = () => {
        const startDate = this.props.form.getFieldValue("startDate") || false;
        const endDate = false;

        return function disabledDate(current) {
            let startCheck = true;
            let endCheck = true;
            if (startDate) {
                startCheck =
                    current && current < moment(startDate, "YYYY-MM-DD").startOf("day");
            }
            if (endDate) {
                endCheck = current && current > moment(endDate, "YYYY-MM-DD");
            }
            return (startDate && startCheck) || (endDate && endCheck);
        };
    };

    range = (start, end) => {
        const result = [];

        for (let i = start; i < end; i++) {
            result.push(i);
        }

        return result;
    }; // eslint-disable-next-line arrow-body-style

    disabledDateTime = () => ({
        disabledHours: () => this.range(0, 2).splice(4, 20),
        disabledMinutes: () => this.range(30, 60),
        disabledSeconds: () => [55, 56],
    });

    getDisabledHours = () => {
        let hours = [];
        const startDate = moment(this.props.form.getFieldValue("startDate")).format(
            "DD-MM-YYYY"
        );
        const currentDate = moment().format("DD-MM-YYYY");
        if (startDate === currentDate) {
            for (let i = 0; i < moment().hour(); i++) {
                hours.push(i);
            }
        }

        return hours;
    };

    getDisabledMinutes = (selectedHour) => {
        let minutes = [];
        const startDate = moment(this.props.form.getFieldValue("startDate")).format(
            "DD-MM-YYYY"
        );
        const currentDate = moment().format("DD-MM-YYYY");
        if (startDate === currentDate) {
            if (selectedHour === moment().hour()) {
                for (let i = 0; i < moment().minute(); i++) {
                    minutes.push(i);
                }
            }
        }
        return minutes;
    };

    getDisabledHoursEnd = () => {
        let hours = [];
        const startDate = moment(this.props.form.getFieldValue("startDate")).format(
            "DD-MM-YYYY"
        );
        const endDate = moment(this.props.form.getFieldValue("endDate")).format(
            "DD-MM-YYYY"
        );
        const starTime = this.props.form.getFieldValue("startTime");
        if (startDate === endDate) {
            for (let i = 0; i < starTime.hour(); i++) {
                hours.push(i);
            }
        }
        return hours;
    };

    getDisabledMinutesEnd = (selectedHour) => {
        let minutes = [];
        const startDate = moment(this.props.form.getFieldValue("startDate")).format(
            "DD-MM-YYYY"
        );
        const endDate = moment(this.props.form.getFieldValue("endDate")).format(
            "DD-MM-YYYY"
        );
        const starTime = this.props.form.getFieldValue("startTime");
        if (startDate === endDate) {
            if (selectedHour === starTime.hour()) {
                for (let i = 0; i < starTime.minute(); i++) {
                    minutes.push(i);
                }
            }
        }
        return minutes;
    };

    onChangeStartDate = (value) => {
        const endDate = moment(this.props.form.getFieldValue("endDate")).format(
            "DD-MM-YYYY"
        );
        const dateStart = value || this.props.form.getFieldValue("startDate");
        const dateStartFormat = moment(dateStart).format("DD-MM-YYYY");
        const startTime = this.props.form.getFieldValue("startTime");
        const endTime = this.props.form.getFieldValue("endTime");

        if (dateStartFormat >= endDate) {
            if (endTime && endTime < startTime) {
                this.props.form.setFieldsValue({
                    endTime: startTime,
                });
            }
        }

        if (endDate && dateStartFormat > endDate) {
            this.props.form.setFieldsValue({
                endDate: dateStart,
            });
        }
    };

    onChangeEndDate = (value) => {
        const startTime = this.props.form.getFieldValue("startTime");
        const startDate = moment(this.props.form.getFieldValue("startDate")).format(
            "DD-MM-YYYY"
        );
        const endDate = value || this.props.form.getFieldValue("endDate");
        const endDateFormat = moment(endDate).format("DD-MM-YYYY");
        const endTime = this.props.form.getFieldValue("endTime");

        if (startDate >= endDateFormat) {
            if (endTime && endTime < startTime) {
                this.props.form.setFieldsValue({
                    endTime: startTime,
                });
            }
        }
    };

    onChangeStartTime = (value) => {
        const startTime = value || this.props.form.getFieldValue("startTime");
        const startDate = moment(this.props.form.getFieldValue("startDate")).format(
            "DD-MM-YYYY"
        );
        const endDate = moment(this.props.form.getFieldValue("endDate")).format(
            "DD-MM-YYYY"
        );
        const endTime = this.props.form.getFieldValue("endTime");

        if (startDate >= endDate) {
            if (endTime && endTime < startTime) {
                this.props.form.setFieldsValue({
                    endTime: startTime,
                });
            }
        }
    };

    // validateDateTime = (rule, value, callback) => {

    //     const startDate = this.props.form.getFieldValue('startDate')
    //     const startTime = this.props.form.getFieldValue('startTime')
    //     const endDate = this.props.form.getFieldValue('endDate')
    //     const endTime = value || this.props.form.getFieldValue('endTime')

    //     if(startDate && startTime && endDate && endTime){
    //         const startDateTime = moment(`${startDate} ${startTime}`)
    //         const endDateTime = moment(`${endDate} ${endTime}`)

    //         if(startDateTime < moment()|| startDateTime > endDateTime){
    //             callback('กรุณาระบุบบบบบ')
    //         } else {
    //             callback()
    //         }
    //     }
    //     callback()
    //     // return false
    // }
    onCheckedInternal = (e, userID) => {
        const { checked } = e.target;

        if (!checked) {
            this.setState({
                isCheckInternal: this.state.isCheckInternal.filter(
                    (item) => item !== userID
                ),
            });
        } else {
            this.setState({
                isCheckInternal: [...this.state.isCheckInternal, userID],
            });
        }
    };

    onCheckedExternal = (e, code) => {
        const { checked } = e.target;

        if (!checked) {
            this.setState({
                isCheckExternal: this.state.isCheckExternal.filter(
                    (item) => item !== code
                ),
            });
        } else {
            this.setState({ isCheckExternal: [...this.state.isCheckExternal, code] });
        }
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        // const props = {
        //     action: 'http://www.mocky.io/v2/5cc8019d300000980a055e76',
        //     onChange: this.handleChangeFile,
        //     multiple: true,
        //   };
        const { match } = this.props;
        const { dataForm, OrgJoinMeeting, currentPaginateGuset } = this.state;

        console.log("currentPaginateGuset", this.state.showlistInviteExternal)

        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {this.state.showModalConfirmErrors && <ModalErrors />}
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <Modal
                    // maskClosable={false}
                    className={"meeting-approver-modal"}
                    visible={this.state.showModalSelectAprover}
                    onCancel={this.handleCancel}
                    closable={true}
                    title="รายชื่อผู้อนุมัติการประชุม "
                    footer={[
                        <Button
                            key="back"
                            className={"btn-modal-cancle"}
                            onClick={this.handleCancel}
                        >
                            ยกเลิก
                        </Button>,
                        <Button
                            key="submit"
                            className={"btn-modal-confirm"}
                            onClick={this.handleOkapproverList}
                            disabled={this.state.approverSelected === null}
                        >
                            ยืนยัน
                        </Button>
                    ]}
                >
                    <Col xs={24} className={"py-1"}>
                        <Input
                            placeholder="ค้นหาตามรายชื่อผู้อนุมัติ"
                            onChange={(e) =>
                                this.onChangeSearchApproverList(e.target.value)
                            }
                            value={this.state.approverSearchInput}
                        />
                    </Col>
                    <div style={{ width: 400 }}>
                        <Col className="my-3" xs={24}>
                            <Select
                                defaultValue=""
                                style={{ width: "100%" }}
                                onChange={(value) => this.onChangeSearchApproverList("", value, true)}
                                value={this.state.approverSearchDropdown}
                            >
                                <Option key={'default'} value="">
                                    <span style={{ color: "#d9d9d9" }}>ค้นหาตามสำนัก</span>
                                </Option>
                                {this.state.dropdownOrg.map((item, i) => (
                                    <Option key={`${item.orgCode}${i}`} value={item.orgCode}>{item.orgName}</Option>
                                ))}
                            </Select>
                        </Col>
                    </div>
                    <div style={{ height: 400, width: 400, overflow: "auto", overflowX: "hidden" }}>
                        <Row gutter={16} className={"pt-0"}>
                            <Radio.Group
                                onChange={this.onCheckSelect}
                                defaultValue=""
                                className="mt-0 w-100"
                                value={this.state.approverSelected?.id + "/" + this.state.approverSelected?.name}
                            >
                                {this.state.approverListSearch.map((user, i) => {
                                    return (
                                        <Col key={user.id} xs={24} className={"py-1 mx-0"} style={{ paddingRight: "0px", paddingLeft: "0px" }}>
                                            <Radio.Button
                                                style={{ width: "95%", border: "transparent" }}
                                                value={user.id + "/" + user.name}
                                            >
                                                {user.name}
                                            </Radio.Button>
                                        </Col>
                                    );
                                })}
                            </Radio.Group>
                        </Row>
                    </div>
                </Modal>
                <Modal
                    className={"meeting-management-modal"}
                    visible={this.state.showModalConfirm}
                    onCancel={this.handleCancel}
                    closable={false}
                    // title="นโยบายความคุ้มครองส่วนบุคคล "
                    footer={[
                        <Button
                            key="back"
                            className={"btn-modal-cancle"}
                            onClick={this.handleCancel}
                        >
                            ยกเลิก
                        </Button>,
                        <Button
                            key="submit"
                            className={"btn-modal-confirm"}
                            onClick={this.handleOk}
                        >
                            ยอมรับ
                        </Button>,
                    ]}>
                    <div style={{ textAlign: "center" }}>
                        {this.state.statusMeeting === MEETING_STATUS.WAITING_APPROVE ? (
                            <p style={{ fontSize: "18px" }}>
                                คุณต้องการแก้ไข <br />
                                รายการขออนุมัติการประชุม
                                <br />
                                ใช่หรือไม่
                            </p>)
                            :
                            this.state.statusMeeting === MEETING_STATUS.EDIT_APPROVE ? (
                                <p style={{ fontSize: "18px" }}>
                                    คุณต้องการบันทึกการแก้ไขและอนุมัติ <br />
                                    การสร้างประชุมของ<br />
                                    <span style={{ color: 'black' }}>"{this.state.OrganizerDetail.firstName + " " + this.state.OrganizerDetail.lastName}"</span> ใช่หรือไม่
                                </p>)
                                :
                                (<p style={{ fontSize: "18px" }}>
                                    คุณต้องการส่งคำเชิญประชุม
                                    <br />
                                    ใช่หรือไม่
                                </p>)
                        }
                    </div>
                </Modal>
                <Modal
                    className={"meeting-management-modal"}
                    visible={this.state.showModalSave}
                    onCancel={this.handleCancel}
                    closable={false}
                    // title="นโยบายความคุ้มครองส่วนบุคคล "
                    footer={[
                        <Button
                            key="back"
                            className={"btn-modal-cancle"}
                            onClick={this.handleCancel}
                        >
                            ยกเลิก
                        </Button>,
                        <Button
                            key="submit"
                            className={"btn-modal-confirm"}
                            onClick={this.handleOkSaveDraft}
                        >
                            ยอมรับ
                        </Button>,
                    ]}
                >
                    <div style={{ textAlign: "center" }}>
                        <p style={{ fontSize: "18px" }}>
                            คุณต้องการบันทึก
                            <br />
                            เป็นการประชุมฉบับร่าง
                            <br />
                            ใช่หรือไม่
                        </p>
                    </div>
                </Modal>
                <Modal
                    className={"meeting-management-modal"}
                    visible={this.state.showModalSuccess}
                    onCancel={this.handleCancel}
                    footer={null}
                    closable={false}
                >
                    <div
                        className={"py-5"}
                        style={{ textAlign: "center", color: "#178991" }}
                    >
                        <Icon
                            style={{ fontSize: "70px", paddingBottom: "30px" }}
                            type="check-circle"
                        />
                        <p style={{ fontSize: "20px", whiteSpace: 'break-spaces' }}>{this.state.textModalSuccess}</p>
                    </div>
                </Modal>
                <Modal
                    className={"meeting-management-modal"}
                    visible={this.state.showModalSureInternal}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button
                            key="back"
                            className={"btn-modal-cancle"}
                            onClick={this.handleCancel}
                        >
                            ยกเลิก
                        </Button>,
                        <Button
                            key="submit"
                            className={"btn-modal-confirm"}
                            onClick={this.handleOkSaveInternalSuccess}
                        >
                            ยืนยัน
                        </Button>,
                    ]}
                    closable={false}
                >
                    <div align="center">
                        <p style={{ fontSize: "20px" }}>
                            คุณต้องการส่งคำเชิญประชุม
                            <br />
                            ใช่หรือไม่
                        </p>
                    </div>
                </Modal>
                <Modal
                    className={"meeting-management-modal"}
                    visible={this.state.showModalSureExternal}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button
                            key="back"
                            className={"btn-modal-cancle"}
                            onClick={this.handleCancel}
                        >
                            ยกเลิก
                        </Button>,
                        <Button
                            key="submit"
                            className={"btn-modal-confirm"}
                            onClick={this.handleOkSaveExternalSuccess}
                        >
                            ยืนยัน
                        </Button>,
                    ]}
                    closable={false}
                >
                    <div align="center">
                        <p style={{ fontSize: "20px" }}>
                            คุณต้องการส่งคำเชิญประชุม
                            <br />
                            ใช่หรือไม่
                        </p>
                    </div>
                </Modal>
                <Modal
                    destroyOnClose={true}
                    maskClosable={false}
                    className={"list-invite-internal-modal"}
                    visible={this.state.showModallistInviteInternal}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button
                            key="back"
                            className={"btn-modal-cancle"}
                            onClick={this.handleCancel}
                        >
                            ยกเลิก
                        </Button>,
                        <Button
                            key="submit"
                            className={"btn-modal-confirm"}
                            disabled={
                                this.state.showlistInviteExternal.length === 0
                            }
                            onClick={this.handleOkSaveInternal}
                        >
                            ยืนยัน
                        </Button>,
                    ]}
                >
                    <Row gutter={16}>
                        <Spin
                            tip="Loading..."
                            size="large"
                            spinning={this.state.loadingInternal}
                            style={{ alignItems: "center", position: "initial" }}
                        >
                            <Col xs={24} className={"pb-3"}>
                                <h1 className="mb-3">เพิ่มผู้เข้าร่วมภายใน</h1>
                                <Input
                                    placeholder="ค้นหา"
                                    onChange={(value) => this.ChangeTextSearch(value)}
                                />
                            </Col>
                            <Col className="mb-1" xs={24}>
                                <h2 className="mb-1">กลุ่ม</h2>
                                <Select
                                    defaultValue=""
                                    style={{ width: "100%" }}
                                    onChange={this.ChangeGroup}
                                >
                                    <Option key={'default'} value="">
                                        <p style={{ color: "#d9d9d9" }}>กรุณาเลือกกลุ่ม</p>
                                    </Option>
                                    {this.state.dropdownGroup.map((item) => (
                                        <Option key={item.id} value={item.id}>{item.groupName}</Option>
                                    ))}
                                </Select>
                            </Col>
                            <Col className="mb-1" xs={24}>
                                <h2 className="mb-1">สำนัก</h2>
                                <Select
                                    defaultValue=""
                                    style={{ width: "100%" }}
                                    onChange={this.ChangeOrg}
                                >
                                    <Option key={'default'} value="">
                                        <p style={{ color: "#d9d9d9" }}>กรุณาเลือกสำนัก</p>
                                    </Option>
                                    {this.state.dropdownOrg.map((item) => (
                                        <Option key={item.orgCode} value={item.orgCode}>{item.orgName}</Option>
                                    ))}
                                </Select>
                            </Col>
                            <Col className="mb-1" xs={24}>
                                <h2 className="mb-1">หน่วยงาน</h2>
                                <Select
                                    disabled={
                                        this.state.dropdownDivision.length === 0
                                    }
                                    defaultValue=""
                                    value={this.state.valueSelectDiv}
                                    style={{ width: "100%" }}
                                    onChange={this.ChangeDiv}
                                >
                                    <Option key={'default'} value="">
                                        <p style={{ color: "#d9d9d9" }}>กรุณาเลือกฝ่าย</p>
                                    </Option>
                                    {this.state.dropdownDivision.map((item) => (
                                        <Option key={item.userID} value={item.divisionCode}>
                                            {item.divisionName}
                                        </Option>
                                    ))}
                                </Select>
                            </Col>
                            <Col className="mb-1" xs={24}>
                                <h2 className="mb-1">แผนก</h2>
                                <Select
                                    disabled={
                                        this.state.dropdownDepartment.length === 0
                                    }
                                    defaultValue=""
                                    value={this.state.valueSelectDep}
                                    style={{ width: "100%" }}
                                    onChange={this.ChangeDep}
                                >
                                    <Option key={'default'} value="">
                                        <p style={{ color: "#d9d9d9" }}>กรุณาเลือกแผนก</p>
                                    </Option>
                                    {this.state.dropdownDepartment.map((item) => (
                                        <Option key={item.userID} value={item.departmentCode}>
                                            {item.departmentName}
                                        </Option>
                                    ))}
                                </Select>
                            </Col>
                            <Col className="mt-3" xs={24}>
                                <Button
                                    key="submit"
                                    disabled={!this.state.groupCode && !this.state.valueSelectOrg}
                                    className={"btn-modal-confirm w-100 mb-2"}
                                    onClick={this.confirmSearch}
                                >
                                    ค้นหา
                                </Button>
                            </Col>
                            {this.state.inviteInternal.length > 0 ? (
                                <div>
                                   {/* <Form onSubmit={this.handleSubmit}  > */}
                                       {this.state.inviteInternal.map((user, i) => {
                                          return (
                                             <Col key={user.userID} xs={24} className={"py-1"}>
                                                      <Checkbox
                                                         onChange={(e) => this.onCheckAddInternal(e, user)}
                                                         name={
                                                            user.title +
                                                            " " +
                                                            user.firstName +
                                                            " " +
                                                            user.lastName
                                                         }
                                                         value={user.empCode}
                                                         name={user.empCode}
                                                         className="checkbox-listInviteInternal"
                                                      >
                                                         <p style={{ fontSize: "14px", display: "inline" }}>
                                                            {user.title} {user.firstName} {user.lastName} {user.positionName ? `- ${user.positionName}` : user.positionName} {user.divisionName ? `- ${user.divisionName}` : user.divisionName}
                                                         </p>
                                                      </Checkbox>
                                             </Col>
                                          );
                                       })}
                                    {/* </Form> */}
                                    {this.state.totalpaginateGuset != 0 ? (
                                       <Col md={24} className={"pt-3"}>
                                          <Pagination
                                             onChange={this.onChangePage}
                                             current={this.state.currentPaginateGuset}
                                             total={this.state.totalpaginateGuset}
                                          />
                                       </Col>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            ) : this.state.isSearch ? (
                                <Col xs={24} md={24} align={"center"}>
                                    <Text>ไม่พบข้อมูลรายการ</Text>
                                </Col>
                            ) : null}
                        </Spin>
                    </Row>
                </Modal>
                <Modal
                    destroyOnClose={true}
                    maskClosable={false}
                    className={"list-invite-external-modal"}
                    visible={this.state.showModallistInviteExternal}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button
                            key="back"
                            className={"btn-modal-cancle"}
                            onClick={this.handleCancel}
                        >
                            ยกเลิก
                        </Button>,
                        <Button
                            key="submit"
                            className={"btn-modal-confirm"}
                            onClick={
                                this.state.isEditExternal
                                    ? this.handleSaveEditExternal
                                    : this.handleOkSaveExternal
                            }
                        >
                            ยืนยัน
                        </Button>,
                    ]}
                >
                    <Row gutter={16}>
                        <Col
                            xs={24}
                            className={"mb-3"}
                            style={{ height: 500, width: 500, overflow: "auto" }}
                        >
                            <h1>
                                {this.state.isEditExternal
                                    ? "แก้ไขผู้เข้าร่วมภายนอก"
                                    : "เพิ่มผู้เข้าร่วมภายนอก"}
                            </h1>
                            <AddMeeting
                                dataInvite={this.state.listInviteInternal}
                                onChangeNameExternal={this.onChangeNameOrEmailExternal}
                                onChangeEmailExternal={this.onChangeNameOrEmailExternal}
                                onChangeSwitchExternal={this.onChangeSwitchExternal}
                                NameExternal={this.state.NameExternal}
                                countAddBlock={this.state.countAddBlock}
                                countInviteExternal={this.state.countInviteExternal}
                                countInviteExternalAll={this.state.countInviteExternalAll}
                                isEditExternal={this.state.isEditExternal}
                                listDeleteInviteInternal={this.state.listDeleteInviteInternal}
                                AddInviteInternal={this.state.AddInviteInternal}
                            ></AddMeeting>
                        </Col>
                        {!this.state.isEditExternal && (
                            <Col xs={24}>
                                <Button
                                    className={"button-meeting-add"}
                                    onClick={this.addExternalCount}
                                >
                                    <Icon type="plus" />
                                    เพิ่ม
                                </Button>
                            </Col>
                        )}
                    </Row>
                </Modal>
                <Modal
                    className={"meeting-management-modal"}
                    visible={this.state.showModalDeleteMeeting}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button
                            key="back"
                            className={"btn-modal-red-cancle"}
                            onClick={this.handleCancel}
                        >
                            ยกเลิก
                        </Button>,
                        <Button
                            key="submit"
                            className={"btn-modal-red-confirm"}
                            onClick={this.handleOkDeleteMeeting}
                        >
                            ยืนยัน
                        </Button>,
                    ]}
                    closable={false}
                >
                    <div className="py-5" align="center">
                        <p style={{ fontSize: "20px" }}>
                            คุณต้องการลบ
                            <br />
                            การประชุมฉบับร่างนี้
                            <br />
                            ใช่หรือไม่
                        </p>
                    </div>
                </Modal>
                <Modal
                    className={"meeting-management-modal"}
                    visible={this.state.showModalConfirmDelete}
                    onCancel={this.handleCancel}
                    footer={null}
                    closable={false}
                >
                    <div
                        className={"py-5"}
                        style={{ textAlign: "center", color: "#d7222a" }}
                    >
                        <Icon
                            style={{ fontSize: "70px", paddingBottom: "30px" }}
                            type="close-circle"
                        />
                        <p style={{ fontSize: "20px" }}>{this.state.textModalDelete}</p>
                    </div>
                </Modal>
                <Modal
                    className={"meeting-management-modal"}
                    visible={this.state.showModalDeleteInviteExternal}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button
                            key="back"
                            className={"btn-modal-red-cancle"}
                            onClick={this.handleCancel}
                        >
                            ยกเลิก
                        </Button>,
                        <Button
                            key="submit"
                            className={"btn-modal-red-confirm"}
                            onClick={this.handleOkDeleteInviteExternal}
                        >
                            ยืนยัน
                        </Button>,
                    ]}
                    closable={false}
                >
                    <div className="py-5" align="center">
                        <p style={{ fontSize: "20px" }}>
                            คุณต้องการลบ
                            <br />
                            {this.state.listDeleteInviteExternal.map((user, i) => {
                                return <h4>{user.name}</h4>;
                            })}
                            ใช่หรือไม่
                        </p>
                    </div>
                </Modal>
                <Modal
                    className={"meeting-management-modal"}
                    visible={this.state.showModalDeleteInviteInternal}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button
                            key="back"
                            className={"btn-modal-red-cancle"}
                            onClick={this.handleCancel}
                        >
                            ยกเลิก
                        </Button>,
                        <Button
                            key="submit"
                            className={"btn-modal-red-confirm"}
                            onClick={this.handleOkDeleteInviteInternal}
                        >
                            ยืนยัน
                        </Button>,
                    ]}
                    closable={false}
                >
                    <div className="py-5" align="center">
                        <p style={{ fontSize: "20px" }}>
                            คุณต้องการลบ
                            <br />
                            {this.state.listDeleteInviteInternal.map((user, i) => {
                                return <h4>{user.Name}</h4>;
                            })}
                            ใช่หรือไม่
                        </p>
                    </div>
                </Modal>
                <Modal
                    className={"meeting-management-modal"}
                    visible={this.state.showModalConfirmFail}
                    onCancel={this.handleCancel}
                    footer={null}
                    closable={false}
                >
                    <div
                        className={"py-5"}
                        style={{ textAlign: "center", color: "#d7222a" }}
                    >
                        <Icon
                            style={{ fontSize: "70px", paddingBottom: "30px" }}
                            type="delete"
                        />
                        <p style={{ fontSize: "20px" }}>{this.state.textModalDelete}</p>
                    </div>
                </Modal>
                <LocaleProvider locale={thTH}>
                    <Spin
                        tip="Loading..."
                        size="large"
                        spinning={this.state.loadingFullpage}
                        style={{ alignItems: "center", position: "initial" }}
                    >
                        <div
                            className="card-container meeting-management"
                            id="form:{}-meeting"
                        >
                            <div className="card-bg-white">
                                <Row className="pt-4 pb-3 px-3" gutter={16} type="flex">
                                    {/* {this.state.idMeeting ? (
                                        <Col xs={19}>
                                            <Link onClick={this.props.history.goBack}>
                                                <Icon type="left" className="icon-back-meeting" />
                                                <p style={{ display: "inline", color: "#4D4D4D" }}>
                                                    {" "}
                                                    รายละเอียดการประชุมฉบับร่าง
                                                </p>
                                            </Link>
                                        </Col>
                                    ) : ( */}
                                    <Col xs={19}>
                                        <Link onClick={this.props.history.goBack}>
                                            <Icon type="left" className="icon-back-meeting" />
                                            <p style={{ display: "inline", color: "#4D4D4D" }}>
                                                {["draft", MEETING_STATUS.WAITING_APPROVE].includes(this.state.statusMeeting) ? " รายละเอียดการประชุมฉบับร่าง" :
                                                    this.state.statusMeeting === MEETING_STATUS.EDIT_APPROVE ? " รายละเอียดการประชุม" : " สร้างการประชุมใหม่"}
                                            </p>
                                        </Link>
                                    </Col>
                                    {/* )} */}
                                    <Col xs={5} align={"right"}>
                                        {this.state.idMeeting && this.state.statusMeeting !== MEETING_STATUS.EDIT_APPROVE ? (
                                            <Link
                                                to={{
                                                    pathname: `/meetingmanagement/CreateMeeting/`,
                                                    search: "edit",
                                                }}
                                            >
                                                <Icon
                                                    type="delete"
                                                    style={{ fontSize: "20px", color: "#666666" }}
                                                />
                                            </Link>
                                        ) : (
                                            <></>
                                        )}
                                    </Col>
                                </Row>
                                <Form onSubmit={this.handleSubmit}>
                                    <Row
                                        className="py-5 meeting-date-picker"
                                        gutter={16}
                                        type="flex"
                                        justify="center"
                                        align="top"
                                    >
                                        <Col xs={20} sm={22} md={22} lg={22} xl={17} xxl={14}>
                                            <Col xs={24} md={9}>
                                                <p
                                                    style={{ fontSize: "18px" }}
                                                    className={"color-text-red"}
                                                >
                                                    เชิญประชุม
                                                </p>
                                            </Col>
                                            <Col xs={24} md={15} align="end">
                                                <Col xs={20} md={21} style={{ display: "flex", justifyContent: "flex-end" }}>
                                                    <p style={{ textAlign: "start" }} className={"color-text-gray"}>ผู้สร้างต้องการเข้าร่วมการประชุมด้วยหรือไม่</p>
                                                </Col>
                                                <Col xs={4} md={3} style={{ display: "flex", justifyContent: "flex-end", padding: "0px" }}>
                                                    <Switch
                                                        checked={OrgJoinMeeting}
                                                        onChange={this.JoinMeeting}
                                                    />
                                                </Col>
                                            </Col>

                                            <Col xs={24} md={16}>
                                                <Form.Item
                                                    label={"หัวข้อการประชุม"}
                                                    name={"subject"}
                                                    className="mb-0"
                                                >
                                                    {getFieldDecorator("subject", {
                                                        initialValue: dataForm.subject,
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: "กรุณาระบุ หัวข้อการประชุม",
                                                            },
                                                        ],
                                                    })(
                                                        <Input
                                                            maxLength={125}
                                                            placeholder="กรอกหัวข้อการประชุม"
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={8}>
                                                <Form.Item
                                                    label="วันที่ออกเอกสาร"
                                                    name={"documentDate"}
                                                    className="mb-0"
                                                >
                                                    {getFieldDecorator("documentDate", {
                                                        initialValue:
                                                            dataForm.documentDate || moment().locale("th"),
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: "กรุณาระบุ วันที่ออกเอกสาร",
                                                            },
                                                        ],
                                                    })(
                                                        <WatDatePicker
                                                            value={moment().locale("th")}
                                                            onChange={this.onChangeStartDate}
                                                            displayFormat={'DD MMMM YYYY'}
                                                            clearable={false}
                                                            disabled={false}
                                                            readOnly={false}
                                                            yearBoundary={10} // number of boundary ±X Year
                                                            placeholder="เลือกวันที่"
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                            {this.state.needApprove === "yes" ? (
                                                <>
                                                    <Col xs={24} md={16}>
                                                        <Form.Item
                                                            label={"ผู้อนุมัติ"}
                                                            name={"approverID"}
                                                            className="mb-0 "
                                                        >
                                                            {getFieldDecorator("approverID", {
                                                                initialValue: dataForm.approverName,
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message: "เลือกผู้อนุมัติ",
                                                                    },
                                                                ],
                                                            })(
                                                                <Input disabled />
                                                            )}
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} md={8} style={{ paddingTop: "4px" }}>
                                                        <Form.Item label=" " className="mb-0">
                                                            <Button
                                                                disabled={
                                                                    this.state.statusMeeting === MEETING_STATUS.WAITING_APPROVE ||
                                                                    this.state.statusMeeting === MEETING_STATUS.EDIT_APPROVE
                                                                }
                                                                className={"button-meeting-select w-100"}
                                                                onClick={this.handleSelectApprover}
                                                            >
                                                                เลือกผู้อนุมัติการประชุม
                                                            </Button>
                                                        </Form.Item>
                                                    </Col>
                                                </>
                                            ) : (
                                                <></>
                                            )}
                                            <Col xs={24}>
                                                <Form.Item
                                                    label={"สถานที่การประชุม"}
                                                    name={"location"}
                                                    className="mb-0"
                                                >
                                                    {getFieldDecorator("location", {
                                                        initialValue: dataForm.location,
                                                    })(
                                                        <Input
                                                            maxLength={160}
                                                            placeholder="ระบุสถานที่การประชุม"
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={24} md={12} lg={6}>
                                                <Form.Item
                                                    label="เริ่มต้น"
                                                    name={"startDate"}
                                                    className="mb-0"
                                                >
                                                    {getFieldDecorator("startDate", {
                                                        initialValue:
                                                            dataForm.startDate || moment().locale("th"),
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: "กรุณาระบุ วันที่เริ่มต้น",
                                                            },
                                                        ],
                                                    })(
                                                        <WatDatePicker
                                                            value={moment().locale("th")}
                                                            onChange={this.onChangeStartDate}
                                                            displayFormat={'DD MMMM YYYY'}
                                                            clearable={false}
                                                            minDate={moment().locale("th")}
                                                            disabled={false}
                                                            readOnly={false}
                                                            yearBoundary={10} // number of boundary ±X Year
                                                            placeholder="เลือกวันที่"
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={24} md={12} lg={6}>
                                                <Form.Item label=" " required={false} className="mb-0">
                                                    {getFieldDecorator("startTime", {
                                                        initialValue:
                                                            dataForm.startTime || moment().locale("th"),
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: "กรุณาระบุ เวลาเริ่มต้น",
                                                            },
                                                        ],
                                                    })(
                                                        <TimePicker
                                                            disabledHours={this.getDisabledHours}
                                                            disabledMinutes={this.getDisabledMinutes}
                                                            onChange={this.onChangeStartTime}
                                                            format={TIME_FORMAT}
                                                            className="w-100"
                                                            placeholder="เลือกเวลา"
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={24} md={12} lg={6}>
                                                <Form.Item label="สิ้นสุด" className="mb-0">
                                                    {getFieldDecorator("endDate", {
                                                        initialValue: dataForm.endDate,
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: "กรุณาระบุ วันที่สิ้นสุด",
                                                            },
                                                        ],
                                                    })(
                                                        <WatDatePicker
                                                            value={dataForm.endDate}
                                                            onChange={this.onChangeEndDate}
                                                            displayFormat={'DD MMMM YYYY'}
                                                            clearable={false}
                                                            minDate={this.props.form.getFieldValue("startDate")}
                                                            disabled={false}
                                                            readOnly={false}
                                                            yearBoundary={10} // number of boundary ±X Year
                                                            placeholder="เลือกวันที่"
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={24} md={12} lg={6}>
                                                <Form.Item label=" " required={false} className="mb-0">
                                                    {getFieldDecorator("endTime", {
                                                        initialValue: dataForm.endTime,
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: "กรุณาระบุ เวลาสิ้นสุด",
                                                            },
                                                            // {
                                                            //     validator: this.validateDateTime,
                                                            //     // message: 'ระบุบ เวลาไม่ถูกต้อง'
                                                            // }
                                                        ],
                                                    })(
                                                        <TimePicker
                                                            defaultValue={moment("12:00", TIME_FORMAT)}
                                                            disabledHours={this.getDisabledHoursEnd}
                                                            disabledMinutes={this.getDisabledMinutesEnd}
                                                            format={TIME_FORMAT}
                                                            className="w-100"
                                                            placeholder="เลือกเวลา"
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24}>
                                                <Form.Item className="mb-0">
                                                    <p>
                                                        รายชื่อผู้ถูกเชิญ (
                                                        {this.state.countInviteExternal +
                                                            this.state.countInviteInternal}
                                                        )
                                                    </p>
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} md={11}>
                                                <Form.Item className="mb-0">
                                                    <p>
                                                        ผู้เข้าร่วมภายใน ({0}/
                                                        {this.state.countInviteInternal})
                                                    </p>
                                                    <Button
                                                        className={"button-meeting-main"}
                                                        onClick={this.openModalAddInternal}
                                                    >
                                                        <Icon type="user" />
                                                        เชิญผู้เข้าร่วมภายใน
                                                    </Button>
                                                    {this.state.listInviteExternal.map((user, i) => {
                                                         console.log("responsresponsee : ususerer", user)
                                                        return (
                                                            <Row gutter={16} className={"pt-2"}>
                                                                <Col xs={22}>
                                                                    <Checkbox
                                                                        checked={this.state.isCheckInternal.includes(
                                                                            user.empCode
                                                                        )}
                                                                        onClick={(e) =>
                                                                            this.onCheckedInternal(e, user.empCode)
                                                                        }
                                                                        onChange={(e) =>
                                                                            this.onCheckDeleteInternal(e, i)
                                                                        }
                                                                        name={user.name}
                                                                        isCheckInternal
                                                                        value={user.code}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                fontSize: "17px",
                                                                                display: "inline",
                                                                            }}
                                                                        >
                                                                           {console.log("userxxxxxx", user)}
                                                                            {i + 1}. {user.name} 
                                                                        </p>
                                                                    </Checkbox>
                                                                </Col>
                                                                <Col xs={2}>
                                                                    {user.status==="confirm" ? (
                                                                        <p
                                                                            style={{
                                                                                fontSize: "19px",
                                                                                display: "inline",
                                                                            }}
                                                                        >
                                                                            <Icon
                                                                                style={{ color: "#16CB69" }}
                                                                                type="check-circle"
                                                                            />
                                                                        </p>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                    {user.status==="wait" ? (
                                                                        <p
                                                                            style={{
                                                                                fontSize: "19px",
                                                                                display: "inline",
                                                                            }}
                                                                        >
                                                                            <Icon
                                                                                style={{ color: "#FDB75D" }}
                                                                                type="exclamation-circle"
                                                                            />
                                                                        </p>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                    {user.status==="cancel" ? (
                                                                        <p
                                                                            style={{
                                                                                fontSize: "19px",
                                                                                display: "inline",
                                                                            }}
                                                                        >
                                                                            <Icon
                                                                                style={{ color: "#d7222a" }}
                                                                                type="close-circle"
                                                                            />
                                                                        </p>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        );
                                                    })}
                                                    {this.state.listDeleteInviteExternal.length != 0 ? (
                                                        <Button
                                                            onClick={this.openModalDeleteInviteExternal}
                                                            style={{ color: "#d7222a" }}
                                                            className={"button-meeting-delete"}
                                                        >
                                                            <Icon type="delete" />
                                                            ลบ
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            onClick={this.openModalDeleteInviteExternal}
                                                            disabled
                                                            style={{ backgroundColor: "transparent" }}
                                                            className={"button-meeting-delete"}
                                                        >
                                                            <Icon type="delete" />
                                                            ลบ
                                                        </Button>
                                                    )}
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={{ span: 11, offset: 2 }}>
                                                <Form.Item className="mb-0">
                                                    <p>
                                                        ผู้เข้าร่วมภายนอก (
                                                        {this.state.conutInviteExternalAccept}/
                                                        {this.state.countInviteExternal})
                                                    </p>
                                                    <Button
                                                        className={"button-meeting-main"}
                                                        onClick={this.openModalAddExternal}
                                                    >
                                                        <Icon type="user" />
                                                        เชิญผู้เข้าร่วมภายนอก
                                                    </Button>
                                                    {this.state.listInviteInternal.map((user, i) => {
                                                        return (
                                                            <Row gutter={16} className={"pt-2"}>
                                                                <Col xs={22}>
                                                                    <Checkbox
                                                                        onClick={(e) =>
                                                                            this.onCheckedExternal(e, user.code)
                                                                        }
                                                                        key={i}
                                                                        checked={this.state.isCheckExternal.includes(
                                                                            user.code
                                                                        )}
                                                                        onChange={(e) =>
                                                                            this.onCheckDeleteExternal(e, i)
                                                                        }
                                                                        name={user.Name}
                                                                        value={user.code}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                fontSize: "17px",
                                                                                display: "inline",
                                                                            }}
                                                                        >
                                                                            {i + 1}. {user.Name}
                                                                        </p>
                                                                    </Checkbox>
                                                                </Col>
                                                                <Col xs={2}>
                                                                    {user.status==="confirm" ? (
                                                                        <p
                                                                            style={{
                                                                                fontSize: "19px",
                                                                                display: "inline",
                                                                            }}
                                                                        >
                                                                            <Icon
                                                                                style={{ color: "#16CB69" }}
                                                                                type="check-circle"
                                                                            />
                                                                        </p>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                    {user.status==="wait" ? (
                                                                        <p
                                                                            style={{
                                                                                fontSize: "19px",
                                                                                display: "inline",
                                                                            }}
                                                                        >
                                                                            <Icon
                                                                                style={{ color: "#FDB75D" }}
                                                                                type="exclamation-circle"
                                                                            />
                                                                        </p>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                    {user.status==="cancel" ? (
                                                                        <p
                                                                            style={{
                                                                                fontSize: "19px",
                                                                                display: "inline",
                                                                            }}
                                                                        >
                                                                            <Icon
                                                                                style={{ color: "#d7222a" }}
                                                                                type="close-circle"
                                                                            />
                                                                        </p>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        );
                                                    })}

                                                    <Row gutter={16}>
                                                        <Col xs={{ span: 12, offset: 0 }}>
                                                            {this.state.listDeleteInviteInternal.length !=
                                                                0 ? (
                                                                <Button
                                                                    onClick={this.openModalDeleteInviteInternal}
                                                                    style={{ color: "#d7222a" }}
                                                                    className={"button-meeting-delete"}
                                                                >
                                                                    <Icon type="delete" />
                                                                    ลบ
                                                                </Button>
                                                            ) : (
                                                                <Button
                                                                    onClick={this.openModalDeleteInviteInternal}
                                                                    disabled
                                                                    style={{ backgroundColor: "transparent" }}
                                                                    className={"button-meeting-delete"}
                                                                >
                                                                    <Icon type="delete" />
                                                                    ลบ
                                                                </Button>
                                                            )}
                                                        </Col>
                                                        <Col xs={{ span: 12, offset: 0 }}>
                                                            <Button
                                                                className={"button-meeting-delete"}
                                                                disabled={
                                                                    this.state.listDeleteInviteInternal.length ===
                                                                    0
                                                                }
                                                                onClick={this.openModalEditExternal}
                                                                style={
                                                                    this.state.listDeleteInviteInternal.length ===
                                                                        0
                                                                        ? { backgroundColor: "transparent" }
                                                                        : { color: "#3C8BE9" }
                                                                }
                                                            >
                                                                <Icon type="edit" />
                                                                แก้ไข 
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24}>
                                                <Form.Item label="รายละเอียด" className="mb-0">
                                                    {getFieldDecorator("detail", {
                                                        initialValue: dataForm.detail,
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: "กรุณาระบุ รายละเอียด",
                                                            },
                                                        ],
                                                    })(
                                                        <TextArea
                                                            maxLength={160}
                                                            rows={8}
                                                            placeholder="กรอกรายละเอียด"
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24}>
                                                <Form.Item label={"ลิงค์การประชุม"}>
                                                    {getFieldDecorator("meetingURL", {
                                                        initialValue: dataForm.meetingURL,
                                                    })(
                                                        <Input placeholder="กรอกลิงค์สำหรับการประชุมออนไลน์" />
                                                    )}
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24}>
                                                <span onClick={() => this.refs.fileInput.click()} style={{ cursor: "pointer", color: "#3C8BE9" }}>
                                                    <Icon type="paper-clip" />
                                                    แนบไฟล์
                                                </span>
                                                <span style={{ color: '#666666' }}>{" (PDF,Word,Excel,PowerPoint,Picture,Zip)"}</span>
                                                <input
                                                    id={"input-file"}
                                                    className="input-file"
                                                    type="file"
                                                    ref="fileInput"
                                                    onChange={this.changeHandler}
                                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                                                    application/vnd.ms-excel,
                                                    .doc,
                                                    .docx,
                                                    application/msword,
                                                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                                    application/pdf,
                                                    application/vnd.ms-powerpoint,
                                                    application/vnd.openxmlformats-officedocument.presentationml.slideshow,
                                                    application/vnd.openxmlformats-officedocument.presentationml.presentation,
                                                    image/png,
                                                    image/jpeg,
                                                    application/zip,
                                                    application/x-zip-compressed,
                                                    multipart/x-zip"
                                                />
                                                {this.state.fileList.map((file, i) => {
                                                    return (
                                                        <div>
                                                            <p
                                                                className="mt-2 mb-0"
                                                                style={{
                                                                    color: "gray",
                                                                    padding: "3px 16px",
                                                                    display: "inline-block",
                                                                    border: "1px solid gray",
                                                                    borderRadius: "20px",
                                                                    fontSize: "14px",
                                                                }}
                                                            >
                                                                <Icon type="file" className="pr-3" />
                                                                {file.id ? (
                                                                    <a
                                                                        style={{ color: "gray" }}
                                                                        href={`${UrlMeeting()}/meeting/file/${file.fileNameGen}`}
                                                                        download
                                                                        target="_blank"
                                                                    >
                                                                        {file.fileName}
                                                                    </a>
                                                                ) : (
                                                                    <a style={{ color: "gray" }}>{file.name}</a>
                                                                )}
                                                                {file.id ? (
                                                                    <Popconfirm
                                                                        placement="topLeft"
                                                                        title={"คุณต้องการลบไฟล์แนบเอกสารนี้"}
                                                                        onConfirm={() =>
                                                                            this.destroyFileList(i, file.id)
                                                                        }
                                                                        okText="ตกลง"
                                                                        cancelText="ยกเลิก"
                                                                    >
                                                                        <Icon
                                                                            type="close"
                                                                            className="pl-3 color-red"
                                                                        />
                                                                    </Popconfirm>
                                                                ) : (
                                                                    <Popconfirm
                                                                        placement="topLeft"
                                                                        title={"คุณต้องการลบไฟล์แนบเอกสารนี้"}
                                                                        onConfirm={() => this.destroyFileList(i)}
                                                                        okText="ตกลง"
                                                                        cancelText="ยกเลิก"
                                                                    >
                                                                        <Icon
                                                                            type="close"
                                                                            className="pl-3 color-red"
                                                                        />
                                                                    </Popconfirm>
                                                                )}
                                                            </p>
                                                        </div>
                                                    );
                                                })}
                                            </Col>
                                            {[MEETING_STATUS.WAITING_APPROVE, MEETING_STATUS.EDIT_APPROVE].includes(this.state.statusMeeting) ? (
                                                <div>
                                                    <Col
                                                        xs={24}
                                                        md={{ span: 8, offset: 8 }}
                                                        lg={{ span: 5, offset: 14 }}
                                                    >
                                                        <Button
                                                            onClick={this.props.history.goBack}
                                                            className={"button-meeting-transparent w-100"}
                                                        >
                                                            ยกเลิก
                                                        </Button>
                                                    </Col>
                                                    <Col xs={24} md={8} lg={5}>
                                                        {/* <Button className={'button-meeting w-100'} onClick={this.handleOpen}> */}
                                                        <Button
                                                            className={"button-meeting w-100"}
                                                            onClick={this.handleOpen}
                                                        >{this.state.statusMeeting === MEETING_STATUS.EDIT_APPROVE ? "อนุมัติ" : "ส่งขออนุมัติ"}
                                                        </Button>
                                                    </Col>
                                                </div>
                                            ) : (
                                                <div>
                                                    <Col xs={24} md={8} lg={{ span: 5, offset: 9 }}>
                                                        <Button
                                                            onClick={this.props.history.goBack}
                                                            className={"button-meeting-transparent w-100"}
                                                        >
                                                            ยกเลิก
                                                        </Button>
                                                    </Col>
                                                    <Col xs={24} md={8} lg={5}>
                                                        <Button
                                                            className={"button-meeting-transparent w-100"}
                                                            onClick={this.handleOpenSave}
                                                        >
                                                            บันทึกฉบับร่าง
                                                        </Button>
                                                    </Col>
                                                    <Col xs={24} md={8} lg={5}>
                                                        {/* <Button className={'button-meeting w-100'} onClick={this.handleOpen}> */}
                                                        <Button
                                                            className={"button-meeting w-100"}
                                                            onClick={this.handleOpen}
                                                        >
                                                            {this.state.needApprove==="yes" ? "ส่งขออนุมัติ" : "ส่งคำเชิญประชุม"}
                                                        </Button>
                                                    </Col>
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </div>
                    </Spin>
                </LocaleProvider>
            </Container>
        );
    }
}

CreateMeetingForm.defaultProps = {
    autoFocus: false,
};

CreateMeetingForm.propTypes = {};

const WrappedSearchForm = Form.create()(CreateMeetingForm);

export default withApollo(WrappedSearchForm);
